import React from 'react';
import {CHECKBOX_SIZES, TRISTATE_CHECKBOX_VALUES, TristateCheckbox} from '../../../tristate-checkbox/tristate-checkbox';
import FontBody2 from '../../../../fonts/font-body2/font-body2';
import {FONT_VARIANT} from '../../../../fonts/font-props';
import './checkboxes-tree-select-all.scss';
import {observer} from "mobx-react";

interface INestedCheckboxesListSelectAllProps {
    disabled: boolean;
    selectAllText: string;
    value: TRISTATE_CHECKBOX_VALUES;
    onToggle: () => void;
    onChange: (next: TRISTATE_CHECKBOX_VALUES) => void;
}

/** Renders the Select All control for the nested checkboxes list. */
const NestedCheckboxesListSelectAll: React.FC<INestedCheckboxesListSelectAllProps> = observer(({
    disabled,
    selectAllText,
    value,
    onToggle,
    onChange
}) => {
    return (
        <div className={`select-all-container ${disabled ? 'disabled' : ''}`}>
            <div className="select-all-heading" onClick={onToggle}>
                <div className="tristate-checkbox-wrapper" onClick={(e) => e.stopPropagation()}>
                    <TristateCheckbox
                        label={""}
                        value={value}
                        size={CHECKBOX_SIZES.MEDIUM}
                        onChange={onChange}
                        disabled={disabled}
                    />
                </div>
                <FontBody2 variant={FONT_VARIANT.BOLD}>{selectAllText}</FontBody2>
            </div>
        </div>
    );
});

export default NestedCheckboxesListSelectAll;


